var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { action, runInAction } from 'mobx';
import './AspectBackgroundVideo.css';
import { runtime } from '../../../classes/runtime/Runtime';
let AspectBackgroundVideo_ = class AspectBackgroundVideo_ extends React.PureComponent {
    render() {
        const { video } = this.props;
        const aspect = this.props.aspect || video.parent;
        if (!video || !video.vid)
            return null;
        if (video.vid.src.startsWith('data:'))
            return null;
        // if (video.vid.base64.length > 0) return null;
        if (!runtime.streamedPackages.Rare)
            return null;
        const { ReactPlayer } = runtime.availablePackages.Rare.classes;
        return (React.createElement(ReactPlayer, { key: video.vid.tid, url: video.vid.src, className: "stretchVideo", style: {
                position: 'absolute',
                zIndex: 0,
                width: aspect.aspectMount.mountDimensions.aspectWidthInPixel,
                height: aspect.aspectMount.mountDimensions.aspectHeightInPixel,
            }, width: aspect.aspectMount.mountDimensions.aspectWidthInPixel, height: aspect.aspectMount.mountDimensions.aspectHeightInPixel, playing: video.shouldPlay, loop: false, controls: false, ref: reactPlayer => {
                if (reactPlayer) {
                    video.reactPlayer = reactPlayer;
                }
            }, progressInterval: 200, onReady: () => {
                runtime.runtimeScheduler.addToNextStateChange(() => {
                    if (!!video.valueOf.playOnReady) {
                        video.shouldPlayTrigger = true;
                    }
                });
            }, onStart: () => {
                runtime.runtimeScheduler.addToNextStateChange(() => {
                    video.isPlaying = true;
                    video.startDate = runtime.runtimeClock.currentDate;
                });
            }, onPlay: () => {
                runtime.runtimeScheduler.addToNextStateChange(() => {
                    video.isPlaying = true;
                });
            }, onProgress: ({ played, loaded, loadedSeconds }) => {
                runtime.runtimeScheduler.addToNextStateChange(() => {
                    video.currentPositionInSeconds = played * video.vid.durationInSeconds;
                    //  video.h();
                });
                if (!runtime.runtimePermissions.hasEditFunctionality)
                    return;
                if (loaded === 1 && !video.vid.durationInSeconds) {
                    video.vid.durationInSeconds = loadedSeconds;
                }
            }, onPause: () => {
                runtime.runtimeScheduler.addToNextStateChange(() => {
                    video.isPlaying = false;
                });
            }, onBuffer: () => { }, onEnded: () => {
                runtime.runtimeScheduler.addToNextStateChange(() => {
                    video.hasEnded = true;
                    video.shouldPlayTrigger = false;
                    video.endDate = runtime.runtimeClock.currentDate;
                });
            }, onError: () => {
                runInAction(() => {
                    video.hasError = true;
                });
            }, onDuration: action((durationInSeconds) => {
                if (!runtime.runtimePermissions.hasEditFunctionality)
                    return;
                if (!isFinite(durationInSeconds))
                    return;
                video.vid.durationInSeconds = durationInSeconds;
            }) }));
    }
    componentDidMount() {
        const { video } = this.props;
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            video.context.app.stage.stageMountedAspects.mountedAspects.push(video.essence);
        });
    }
    componentWillUnmount() {
        const { video } = this.props;
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            video.context.app.stage.stageMountedAspects.mountedAspects.remove(video.essence);
        });
    }
};
AspectBackgroundVideo_ = __decorate([
    observer
], AspectBackgroundVideo_);
export { AspectBackgroundVideo_ };
